import { constants as AUTH } from './auth';

export const constants = {
  SET: {
    SUCCESS: 'BREWERY.SET.SUCCESS'
  },
  UPDATE: {
    SUCCESS: 'BREWERY.UPDATE.SUCCESS'
  }
};

export const initialState = null;

export function reducer(state = initialState, { payload, type }) {
  switch (type) {
    case constants.SET.SUCCESS:
      return payload;
    case constants.UPDATE.SUCCESS:
      return {
        ...state,
        ...payload
      };
    case AUTH.LOGOUT.SUCCESS:
      return initialState;
    default:
      return state;
  }
}

export const actions = {
  setBrewery: brewery => {
    return (dispatch, getState) => {
      const state = getState();
      localStorage.setItem(`tb_${state.auth.profile.id}_lastSelectedBreweryId`, brewery.id);
      dispatch({
        type: constants.SET.SUCCESS,
        payload: brewery
      });
    };
  },
  updateBrewery: brewery => {
    return {
      type: constants.UPDATE.SUCCESS,
      payload: brewery
    };
  }
};



// WEBPACK FOOTER //
// ./src/redux/brewery.js